import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ShoppingPageModule } from './modules/shopping/shopping.module';
import { AirportListComponent } from './modules/airport-list/airport-list.component';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { I18ConfigService } from './services/shared/I18-config.service';
import { EnvironmentConfigService } from './services/shared/environment-config.service';
import { ShoppingSharedModule } from './modules/shopping/shared/shopping-shared.module';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';


export function LanguageLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
@NgModule({
  declarations: [AppComponent, AirportListComponent],
  entryComponents: [AirportListComponent],
  imports: [BrowserModule, IonicModule.forRoot({
    rippleEffect: true,
    mode: 'md'
    // tslint:disable-next-line: max-line-length
  }),
    ShoppingSharedModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (LanguageLoader),
        deps: [HttpClient]
      }
    }),
    ShoppingPageModule,
    HttpClientModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })],
  providers: [
    StatusBar,
    SplashScreen,
    I18ConfigService,
    EnvironmentConfigService,
    GoogleAnalyticsService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
